import React from 'react';
export function ChatIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22a.999.999 0 01-.857-.485L9.033 18H6.57A4.541 4.541 0 012 13.5v-7A4.54 4.54 0 016.57 2h10.86A4.54 4.54 0 0122 6.5v7a4.541 4.541 0 01-4.57 4.5h-2.463l-2.11 3.515A1 1 0 0112 22zM6.57 4A2.538 2.538 0 004 6.5v7A2.538 2.538 0 006.57 16H9.6a1 1 0 01.857.485L12 19.057l1.543-2.572A1 1 0 0114.4 16h3.03A2.538 2.538 0 0020 13.5v-7A2.538 2.538 0 0017.43 4H6.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11a1 1 0 100-2 1 1 0 000 2zM12 11a1 1 0 100-2 1 1 0 000 2zM16 11a1 1 0 100-2 1 1 0 000 2z"
  }));
}